// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1UJAP","head":"ProcedureTableInfo_head__cs_wJ"};